import { render } from "./PrincipalDetailInsightComponent.vue?vue&type=template&id=9f3ac020&scoped=true"
import script from "./PrincipalDetailInsightComponent.vue?vue&type=script&lang=js"
export * from "./PrincipalDetailInsightComponent.vue?vue&type=script&lang=js"

import "./PrincipalDetailInsightComponent.vue?vue&type=style&index=0&id=9f3ac020&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f3ac020"]])

export default __exports__